function Search(options) {
    this.defaults = {};
    $.extend(this.defaults, options);
    this.init();
}

Search.prototype.init = function() {
    var self = this;
};